export interface ApiErrorDetail {
  type: string
  message: string
  reason?: string
  subject?: string
  subjectType?: string
}

export interface ApiErrorList {
  errors: ApiErrorDetail[]
}

export class ApiError extends Error {
  status?: number
  code?: string
  data?: ApiErrorList

  constructor(
    message: string,
    status?: number,
    code?: string,
    data?: ApiErrorList
  ) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.data = data
    // Maintains proper stack trace for custom errors
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError)
    }
  }
}
